/**
 * Detects whether the current browser is running on a real mobile device,
 * as opposed to a desktop browser with a narrow window. Used by the
 * `/mobile-only` gate to show the right message (get-the-app vs widen-window).
 */
export const isMobileDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const isMobileUA =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);

  // iPadOS 13+ reports its user agent as "Macintosh"; disambiguate via touch points.
  const isTouchMac = /Macintosh/.test(ua) && navigator.maxTouchPoints > 1;

  return isMobileUA || isTouchMac;
};
